import {
  loadRole,
  deleteRole,
  addMembersToRole,
  removeMemberFromRole,
  loadUsersForRole,
  loadRolesForUser,
  loadRolesPaginated
} from "hooks/useAuthzRoles";
import notifyingAction from "../notifyingAction";
const load = notifyingAction({
  action: loadRole,
  error: (error, roleId) => ({
    message: `Loading role with id "${roleId}" failed with status: ${error}`
  }),
  notFoundRedirect: true
});
const deleteAction = notifyingAction({
  action: (roleId, _roleName) => deleteRole(roleId),
  success: (_roleId, roleName) => ({
    message: `Role "${roleName}" was deleted successfully`
  }),
  error: (error, _roleId, roleName) => ({
    message: `Deleting role "${roleName}" failed with status: ${error}`
  })
});
const addMembers = notifyingAction({
  action: addMembersToRole,
  success: (_roleId, usernames) => ({
    message: `Users:"${usernames.join(", ")}" were assigned successfully`
  }),
  error: (error, _roleId, usernames) => ({
    message: `Assigning users "${usernames.join(", ")}" failed with status: ${error}`
  })
});
const removeMember = notifyingAction({
  action: removeMemberFromRole,
  success: (_roleId, username) => ({
    message: `User "${username}" was unassigned successfully`
  }),
  error: (error, _roleId, username) => ({
    message: `Unassign user "${username}" failed with status: ${error}`
  })
});
const loadUsersForRoleAction = notifyingAction({
  action: (roleId, _roleName, pagination) => loadUsersForRole(roleId, pagination),
  error: (error, _roleId, roleName) => ({
    message: `Loading users for role "${roleName}" failed with status: ${error}`
  })
});
const loadRolesForUserAction = notifyingAction({
  action: loadRolesForUser,
  error: (error, username) => ({
    message: `Loading roles for user "${username}" failed with status: ${error}`
  })
});
const loadRolesPaginatedAction = notifyingAction({
  action: loadRolesPaginated,
  error: (error) => ({
    message: `Loading roles failed with status: ${error}`
  })
});
export default {
  load,
  delete: deleteAction,
  addMembers,
  removeMember,
  loadUsersForRole: loadUsersForRoleAction,
  loadRolesForUser: loadRolesForUserAction,
  loadRolesPaginated: loadRolesPaginatedAction
};
